export enum InsightsDisplayNameEnum {
    insightsName = 'insightsName',
    custom = 'custom'
}
